import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import { saveAs } from 'file-saver';

import ExportButton from 'components/Export';
import Popup from 'components/Popup';

import { useUserMe } from 'apiTyped/hooks/users.query';
import {
  exportPostsAsXls,
  downloadPostsAsPdf,
  exportPostsAsZip
} from 'api/articles';

const ExportPosts = ({ postsIds = [], postsSearchFilter = {} }) => {
  const { user, isLoading: isLoadingUser } = useUserMe();

  const [loading, setLoading] = useState(false);
  const [popupMessageIsOpen, setPopupIsOpen] = useState(false);

  const PDF_EXPORT_FILES_LIMIT = 30;

  const exportAllAsXls = async () => {
    setLoading(true);
    const response = await exportPostsAsXls({ postsSearchFilter });
    setLoading(false);
    if (response) {
      saveAs(response.blob, response.filename);
    }
  };

  const exportSelectedAsXls = async () => {
    setLoading(true);
    const response = await exportPostsAsXls({ postsIds });
    setLoading(false);
    if (response) {
      saveAs(response.blob, response.filename);
    }
  };

  const exportSelectedAsZip = async ({ postsIds, languageTarget }) => {
    setLoading(true);
    const response = await exportPostsAsZip({
      postsIds,
      languageTarget
    });
    setLoading(false);
    if (response) {
      saveAs(response.blob, response.filename);
    }
  };

  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  const exportSelectedAsPDF = async ({ language_target }) => {
    setLoading(true);
    await downloadPostsAsPdf({ posts_ids: postsIds, language_target });
    setLoading(false);
  };

  const customsOptions = [
    {
      key: 'allAsXls',
      label: I18n.t('media.exportPosts.allAsXls'),
      icon: <FileExcelOutlined style={{ fontSize: 20 }} />,
      onAction: () => exportAllAsXls(),
      disabled: false
    },
    {
      key: 'selectedAsXls',
      label: I18n.t('media.exportPosts.selectedAsXls'),
      icon: <FileExcelOutlined style={{ fontSize: 20 }} />,
      onAction: () => exportSelectedAsXls(),
      disabled: postsIds.length === 0
    },
    // {
    //   key: 'selectedAsPdf',
    //   label: I18n.t('media.exportPosts.selectedAsPdf'),
    //   icon: <FilePdfOutlined style={{ fontSize: 20 }} />,
    //   onAction:
    //     postsIds.length > PDF_EXPORT_FILES_LIMIT
    //       ? () => setPopupIsOpen(true)
    //       : () => exportSelectedAsPDF({ language_target: undefined }),
    //   disabled: postsIds.length === 0
    // },
    {
      key: 'selectedAsTranslatedZip',
      label: I18n.t('media.exportPosts.selectedAsTranslatedZip'),
      icon: <FilePdfOutlined style={{ fontSize: 20 }} />,
      onAction:
        postsIds.length > PDF_EXPORT_FILES_LIMIT
          ? () => setPopupIsOpen(true)
          : () =>
              exportSelectedAsZip({
                postsIds,
                languageTarget: user.language
              }),
      disabled: true
    }
  ];

  return (
    <div>
      <ExportButton
        customOptions={customsOptions}
        loading={loading && isLoadingUser}
        newApi
      />
      <PopupTooMuchFilesSelected
        popupIsOpen={popupMessageIsOpen}
        setPopupIsOpen={setPopupIsOpen}
      />
    </div>
  );
};

const PopupContent = styled.div`
  .popupMessage {
    font-size: 14px;
    line-height: 1.8;
    width: 80%;
    margin-left: 10%;
    font-family: ${(props) => props.theme.fonts.sfcompact};
  }
`;

const PopupTooMuchFilesSelected = ({ popupIsOpen, setPopupIsOpen }) => (
  <Popup
    open={popupIsOpen}
    onClose={() => {
      setPopupIsOpen(false);
    }}
    size={{ height: '200px', width: '600px' }}
    hideButton
  >
    <PopupContent>
      <div className="popupMessage">
        {I18n.t('media.exportPosts.TooMuch30FilesSelected')}
      </div>
    </PopupContent>
  </Popup>
);

export default ExportPosts;
